import gql from 'graphql-tag';

// KIN LIST
export const get = gql`
  query getAllKinships {
    getAllKinships {
      code
      status
      data {
        id
        description
        name
      }
    }
  }
`;

// KIN CREATE
export const save = gql`
  mutation saveKinship($input: KinshipDtoInput) {
    saveKinship(kinshipDto: $input) {
      code
      status
      data {
        id
        name
        description
      }
    }
  }
`;

// KIN UPDATE
export const update = gql`
  mutation updateKinship($input: KinshipDtoInput) {
    updateKinship(kinshipDto: $input) {
      code
      status
      data {
        id
        name
        description
      }
    }
  }
`;

// KIN DELETE
export const remove = gql`
  mutation deleteKinship($input: String) {
    deleteKinship(kinshipId: $input) {
      code
      status
      data {
        id
        name
        description
      }
    }
  }
`;
